import { Input, Tabs, TabItem, Dropdown, Button, CapsuleTab } from '@/components/atoms/index'
import { useState } from 'react';
import { Icon } from '@/icons';
import { vars } from 'style/theme.css';
import LearningCard from '@/components/organisms/Card/LearningCard';
import AcademyExamTable from '@/components/organisms/Table/AcademyExamTable';
import VocabularyTable from '@/components/organisms/Table/VocabularyTable';
import TrophyBadgeCard from '@/components/organisms/Card/TrohyBadgeCard';

const AcademyTeacherDetail = () => {
  return (
    <main className='flex flex-col flex-1 py-8'>
            <div className='flex flex-row justify-between items-center'>
                <h1 className='heading1'>강사상세</h1>
            </div>
            <div className="mt-3">
                <div className="w-full">
                    <ul>
                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>아이디</p>
                            <Input disabled value={'IDID'} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>학원코드</p>
                            <Input disabled value={'qmamm...'} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>이름</p>
                            <Input placeholder='이름을 입력해주세요' className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>생년월일</p>
                            <Input disabled value={'1987.01.12'} className='max-w-[500px] w-full'/>
                        </li>


                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>연락처</p>
                            <Input placeholder='연락처를 입력해주세요' className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>가입 상태</p>
                            <Input disabled value={'승인'} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>강사 상태</p>
                            <Input disabled value={'정상'} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>가입신청일</p>
                            <Input disabled value={'2012.12.12 19:12:12'} className='max-w-[500px] w-full'/>
                        </li>

                    </ul>
                    <div className='flex justify-end *:w-[120px] gap-2  mt-4'>
                        <Button intent='secondary' >퇴원</Button>
                        <Button >저장</Button>
                    </div>
                </div>
            </div>
        </main>
  )
}

export default AcademyTeacherDetail